import { FC } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { openCookieSettings } from '../core/utils/analyticsConsent'
import styles from '../styles/Cookies.module.scss'

const Cookies: FC = () => (
	<>
		<Helmet>
			<title>Политика использования cookies — Podcastbery</title>
			<meta
				name='description'
				content='Какие cookies и технологии хранения данных использует Podcastbery.ru и как управлять согласием на аналитику.'
			/>
			<link rel='canonical' href='https://podcastbery.ru/cookies' />
		</Helmet>
		<main className={styles.page}>
			<div className='container'>
				<article className={styles.article}>
					<nav className={styles.breadcrumbs} aria-label='Хлебные крошки'>
						<Link to='/'>Главная</Link>
						<span aria-hidden='true'>/</span>
						<span>Cookies</span>
					</nav>

					<h1>Политика использования cookies</h1>
					<p className={styles.updated}>Редакция от 17 июля 2026 г.</p>

					<p>
						Настоящая Политика описывает, какие файлы cookies и аналогичные технологии хранения данных использует
						сайт <strong>Podcastbery.ru</strong>, для каких целей и как ими управлять. Она действует совместно с{' '}
						<Link to='/policy'>Политикой конфиденциальности</Link> и{' '}
						<Link to='/user_agreement'>Пользовательским соглашением</Link>.
					</p>

					<h2>Что такое cookies</h2>
					<p>
						Cookies — небольшие текстовые файлы, которые сайт сохраняет в браузере посетителя. Они нужны для работы
						сайта, запоминания настроек и сбора обезличенной статистики о посещениях. Cookies не содержат ФИО,
						адрес или пароль — только технические идентификаторы и значения настроек.
					</p>

					<h2>Какие технологии мы используем</h2>
					<h3>Технические данные (строго необходимые)</h3>
					<p>
						Сайт хранит в localStorage токен авторизации, сведения о пользователе, выбранные язык, страну и город, а
						также другие настройки интерфейса. Эти данные нужны для входа в аккаунт и корректной работы сервиса.
						Если удалить данные авторизации, потребуется войти снова.
					</p>

					<h3>Аналитические — Яндекс.Метрика</h3>
					<p>
						Оператор сервиса — ООО «Яндекс». Метрика помогает понять, как посетители пользуются сайтом, и улучшать
						сервис. Она может собирать посещённые страницы, длительность сессий, источники переходов, тип устройства,
						браузер, разрешение экрана и обезличенный IP-адрес. Вебвизор и карты кликов используются для анализа
						удобства интерфейса. Поля форм маскируются. Счётчик загружается только после вашего согласия.
					</p>
					<p>
						Подробнее: {' '}
						<a href='https://yandex.ru/legal/metrica_termsofuse/' target='_blank' rel='noreferrer'>
							условия использования Яндекс.Метрики
						</a>{' '}
						и{' '}
						<a href='https://yandex.ru/legal/confidential/' target='_blank' rel='noreferrer'>
							политика конфиденциальности Яндекса
						</a>
						. Отключить аналитику можно через настройки на сайте,{' '}
						<a href='https://yandex.ru/support/metrica/general/opt-out.html' target='_blank' rel='noreferrer'>
							официальное расширение Яндекса
						</a>{' '}
						или настройки браузера.
					</p>

					<h3>localStorage</h3>
					<p>
						<strong>podcastbery_cookie_consent_v1</strong> хранит ваш выбор: разрешена ли аналитика. Запись остаётся
						до тех пор, пока вы не измените выбор или не очистите данные сайта в браузере.
					</p>

					<h2>Чего на сайте нет</h2>
					<ul>
						<li>Google Analytics и Facebook Pixel не подключены.</li>
						<li>Рекламные пиксели и ретаргетинг не используются.</li>
					</ul>

					<h2>Как управлять cookies</h2>
					<p>Выбор по аналитике можно изменить в любой момент:</p>
					<button type='button' className={styles.settingsButton} onClick={openCookieSettings}>
						Настроить cookies
					</button>
					<p>
						Также браузер позволяет посмотреть, удалить и заблокировать cookies в разделе «Конфиденциальность» или
						«Безопасность». Инструкции: {' '}
						<a href='https://support.google.com/chrome/answer/95647' target='_blank' rel='noreferrer'>Chrome</a>,{' '}
						<a href='https://support.mozilla.org/ru/kb/udalenie-kuki-i-dannyh-sajtov-v-firefox' target='_blank' rel='noreferrer'>Firefox</a>,{' '}
						<a href='https://support.apple.com/ru-ru/guide/safari/sfri11471/mac' target='_blank' rel='noreferrer'>Safari</a>{' '}
						и{' '}
						<a href='https://support.microsoft.com/ru-ru/microsoft-edge/удаление-файлов-cookie-в-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09' target='_blank' rel='noreferrer'>Edge</a>.
					</p>
					<p>
						<strong>Важно:</strong> если удалить технические данные авторизации, вы выйдете из аккаунта. При отказе
						только от аналитики сайт продолжит работать полноценно.
					</p>

					<h2>Срок хранения</h2>
					<ul>
						<li>Данные авторизации — до выхода из аккаунта или удаления данных сайта.</li>
						<li>Cookies Яндекс.Метрики — по правилам Яндекса, обычно до 13 месяцев.</li>
						<li>Согласие в localStorage — до изменения выбора или очистки браузера.</li>
					</ul>

					<h2>Изменения политики</h2>
					<p>
						При подключении новых аналитических или рекламных систем мы обновим эту страницу. Актуальная редакция
						всегда размещена по адресу podcastbery.ru/cookies, дата последнего обновления указана в начале страницы.
					</p>

					<h2>Вопросы по cookies</h2>
					<p>
						По любым вопросам напишите нам в{' '}
						<a href='https://t.me/podcastberyy' target='_blank' rel='noreferrer'>Telegram</a>. Тема: «Cookies».
					</p>
					<p className={styles.related}>
						Связанные документы: <Link to='/policy'>Политика конфиденциальности</Link>,{' '}
						<Link to='/user_agreement'>Пользовательское соглашение</Link>.
					</p>
				</article>
			</div>
		</main>
	</>
)

export default Cookies
